import { describe, it, expect } from "vitest";
import { resolvePath, pathExists, getLanguageFileExtensions } from "./os_utils";

describe("os_utils", () => {
  describe("resolvePath", () => {
    it("应该解析相对路径", () => {
      const result = resolvePath("./relative/path");
      expect(typeof result).toBe("string");
      expect(result.length).toBeGreaterThan(0);
    });

    it("应该处理绝对路径", () => {
      const result = resolvePath("/absolute/path");
      expect(typeof result).toBe("string");
      expect(result.length).toBeGreaterThan(0);
    });
  });

  describe("pathExists", () => {
    it("应该检查文件存在", () => {
      // 测试当前目录应该存在
      const result = pathExists(".");
      expect(typeof result).toBe("boolean");
    });

    it("应该处理文件不存在", () => {
      // 测试一个不存在的路径
      const result = pathExists("/this/path/does/not/exist/12345");
      expect(result).toBe(false);
    });
  });

  describe("getLanguageFileExtensions", () => {
    it("应该返回 TypeScript 扩展名", () => {
      const result = getLanguageFileExtensions("typescript");
      expect(result).toBe("ts,tsx");
    });

    it("应该返回 JavaScript 扩展名", () => {
      const result = getLanguageFileExtensions("javascript");
      expect(result).toBe("js,jsx,mjs,cjs");
    });

    it("应该返回 Python 扩展名", () => {
      const result = getLanguageFileExtensions("python");
      expect(result).toBe("py,pyw");
    });

    it("应该返回 Java 扩展名", () => {
      const result = getLanguageFileExtensions("java");
      expect(result).toBe("java");
    });

    it("应该返回 C++ 扩展名", () => {
      const result = getLanguageFileExtensions("cpp");
      expect(result).toBe("cpp,hpp,cc,hxx");
    });

    it("应该返回 Go 扩展名", () => {
      const result = getLanguageFileExtensions("go");
      expect(result).toBe("go");
    });

    it("应该返回 Rust 扩展名", () => {
      const result = getLanguageFileExtensions("rust");
      expect(result).toBe("rs");
    });

    it("应该返回未知语言的原始值", () => {
      const result = getLanguageFileExtensions("unknown");
      expect(result).toBe("unknown");
    });

    it("应该处理大小写不敏感", () => {
      const result1 = getLanguageFileExtensions("TypeScript");
      const result2 = getLanguageFileExtensions("TYPESCRIPT");
      const result3 = getLanguageFileExtensions("typescript");

      expect(result1).toBe("ts,tsx");
      expect(result2).toBe("ts,tsx");
      expect(result3).toBe("ts,tsx");
    });
  });
});
